import ObservableComponent from './ObservableComponent'

export default class LoadImage extends ObservableComponent {
  constructor (elem, APP) {
    super(elem, APP)
    this.image = this.elem.querySelector('.js-LoadImage__image')
    this.imgURL = this.elem.getAttribute('data-image-url')
    this.deferred = this.elem.getAttribute('data-deferred')
    this.animation = this.elem.getAttribute('data-animation')
  }

  beforeInView () {
    this.addClass('_before_rendered')
  }

  afterInView () {
    super.afterInView()
    this.loadImage()
  }

  loadImage () {
    let image = new window.Image()
    image.src = this.imgURL
    image.onload = () => {
      this.elem.style.backgroundImage = `url(${this.imgURL})`
      this.image.src = this.imgURL
      this.addClass('_is_rendered')
    }
  }

  init () {
    if (this.animation) {
      this.addClass('image-block--' + this.animation)
    }
    if (!this.deferred) {
      super.init()
    } else {
      this.elem.addEventListener('loadimage', () => {
        this.loadImage()
      })
    }
  }
}
